import { SORT_COMPANIES } from '../types'

export function doSort(field, direction) {
  return {
    type: SORT_COMPANIES,
    payload: { field, direction },
  }
}
